import { render } from "./Topbar2.vue?vue&type=template&id=f1a44018"
import script from "./Topbar2.vue?vue&type=script&lang=js"
export * from "./Topbar2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__